export default __webpack_public_path__ + "static/media/cratk-icon.93f1c6bd.svg";